import { Loader2 } from 'lucide-react'
import { Navigate } from 'react-router'
import { useGetUserSession } from '@/shared/hooks/api/auth'
import { isArtemEarthEmail } from '@/shared/lib/isArtemEarthEmail'

type ArtemEarthOnlyRouteProps = {
  children: React.ReactNode
  /** Newsroom stays on verified Artem admins. Ask Lex uses the email domain only. */
  requireVerifiedEmail?: boolean
}

export function ArtemEarthOnlyRoute({
  children,
  requireVerifiedEmail = true,
}: ArtemEarthOnlyRouteProps) {
  const { data: session, isFetched } = useGetUserSession()

  if (!isFetched) {
    return (
      <div className='flex min-h-svh items-center justify-center'>
        <Loader2 className='size-8 animate-spin text-muted-foreground' />
      </div>
    )
  }

  let isAllowed = isArtemEarthEmail(session?.email)
  if (requireVerifiedEmail) {
    isAllowed = session?.isArtemAdmin === true
  }

  if (!isAllowed) {
    return <Navigate to='/product-catalog' replace />
  }

  return <>{children}</>
}
